import { designImagesModal_userDesigns } from '@/common/queries/types/designImagesModal'

import { cmsCategoryResolver_cmsCategory_products } from '@/common/queries/types/cmsCategoryResolver'
import { searchProducts_productSearch_items } from '@/search/queries/types/searchProducts'
import { ProductCardModel } from '@/search/types'
import {
  additionalOptionsResolver_productOptions
} from '@/product/queries/types/additionalOptionsResolver'

export type DesignImageModalItem = designImagesModal_userDesigns
export type SearchProduct = searchProducts_productSearch_items
export type CMSProduct = cmsCategoryResolver_cmsCategory_products
export type AdditionalOption = additionalOptionsResolver_productOptions

export enum SNACKBAR_LEVELS {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}

export interface SnackbarModel {
  id: string | number
  content: string
  level: SNACKBAR_LEVELS
  duration?: number
  showButton?: boolean
  isShown: boolean
}

export interface CarouselContent {
  imageUrl: string
  altText: string
  destinationUrl: string
  mobileImageUrl: string
}

export interface TopPageIndustry {
  id: number
  displayName: string
  href: string
  topImageSrc: string
  industryImageSrc: string
  background: string
  industryName: string
  description?: string
  keywords: string[]
}

export interface HistoryProduct {
  id: number
  displayName: string
  productImage: string
  displayId?: string
  url: string
  gender: string
  brand: string
  description: string
  quantityUnit: string
  minProductPrice: string
}

export interface DisplayChildCategory {
  id: string
  displayName: string
  thumbnail: string
  alt: string
  url: string
}

export interface RelatedLink  {
  name: string
  url: string
}

export interface DisplayCategory {
  id: string
  displayName: string
  url: string
  iconImage: string
}

export interface ProductGroup {
  id: string
  groupLogo?: string
  groupName: string
  groupUrl?: string
  products: readonly Omit<ProductCardModel, 'productCardItems'>[]
}
